
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetokolhapurcab() {



    const cardData =
    {
        keyword: '  Pune to Kolhapur Cab',
        heading: 'Prince Cabs:  Pune to Kolhapur Cab',
        headingDescription: 'Prince Cabs provides dependable Pune to Kolhapur Cab services, ideal for pilgrimages, family vacations, business trips, and cultural tours. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe and comfortable ride to Kolhapur, home to the famous Mahalaxmi Temple, Panhala Fort, and vibrant local markets. With professional chauffeurs, on-time pickups, and flexible schedules, we make your Pune to Kolhapur journey smooth and stress-free. Enjoy affordability, convenience, and trusted service with Prince Cabs’ dedicated cab service from Pune to Kolhapur.',

        top: 'Top Places to Visit in Kolhapur with Prince Cabs',

"topPlaces": [
  {
    "title": "Mahalaxmi Temple",
    "description": "The Mahalaxmi Temple, also known as Ambabai Temple, is the spiritual heart of Kolhapur and one of the Shakti Peethas of India. Built in the 7th century by the Chalukyas, the temple is dedicated to Goddess Mahalaxmi, believed to grant wealth and prosperity. The intricate stone carvings, sanctum with the idol facing west, and vibrant festivals like Navratri and Kirnotsav attract millions of devotees every year. Its cultural and religious significance makes it a must-visit landmark. The temple is also a fine example of Hemadpanti architecture."
  },
  {
    "title": "Rankala Lake",
    "description": "Rankala Lake is a popular leisure spot in Kolhapur, offering serene views, boating, and a refreshing environment. Built during the reign of Chhatrapati Shahu Maharaj, the lake is surrounded by gardens and food stalls serving local snacks like bhel and pav bhaji. It is particularly lively during evenings when families gather to enjoy the cool breeze. The lake also holds mythological significance, as locals believe it is linked to Lord Shiva’s Nandi. The scenic backdrop makes it ideal for photography and relaxation."
  },
  {
    "title": "New Palace Museum",
    "description": "The New Palace, built in 1884, is a stunning architectural masterpiece combining Hindu and European styles. It was the residence of Chhatrapati Shahu Maharaj and now serves as a museum displaying royal artifacts, weapons, and hunting trophies. The Darbar Hall, adorned with stained glass and chandeliers, is the highlight. Visitors get insights into Kolhapur’s royal legacy and Maratha history. The palace is surrounded by lush gardens, enhancing its grandeur. It is a must-see for history lovers and cultural enthusiasts."
  },
  {
    "title": "Jyotiba Temple",
    "description": "Situated on a hill about 17 km from Kolhapur, Jyotiba Temple is dedicated to Lord Jyotiba, believed to be an incarnation of Lord Shiva. The temple complex, painted in pink, is surrounded by breathtaking views of the Sahyadri hills. Pilgrims flock here during Chaitra Poornima, when lakhs of devotees gather for the annual fair. The temple’s location and spiritual aura make it a peaceful retreat. It is both a pilgrimage site and a scenic spot for visitors. Devotees also believe prayers here help overcome obstacles in life."
  },
  {
    "title": "Panhala Fort",
    "description": "Panhala Fort, located about 20 km from Kolhapur, is a historic hill fort associated with Chhatrapati Shivaji Maharaj. It played a vital role in Maratha history, especially during the Battle of Pavan Khind. The fort’s massive walls, hidden passageways, and bastions reflect brilliant military architecture. Visitors enjoy exploring points like Teen Darwaza, Andhar Bavadi, and Sajja Kothi. The panoramic views of the valley below add to its charm. It is a favorite destination for history buffs and trekkers alike."
  },
  {
    "title": "Kaneri Math (Siddhagiri Museum)",
    "description": "Kaneri Math, also known as Siddhagiri Gramjivan Museum, is a unique open-air museum showcasing the self-sufficient lifestyle of rural Maharashtra. Life-sized clay models depict scenes of village life, including farming, festivals, and traditional crafts. It provides a cultural and educational experience for visitors of all ages. The museum is part of the Siddhagiri Math, a spiritual center dedicated to Lord Shiva. Its creative and informative exhibits make it one of Kolhapur’s most distinctive attractions. Families especially enjoy this blend of culture and learning."
  },
  {
    "title": "Dajipur Wildlife Sanctuary",
    "description": "Also known as the Bison Sanctuary, Dajipur Wildlife Sanctuary is located about 120 km from Kolhapur in the Western Ghats. It is home to the Indian bison (gaur), deer, wild boar, leopards, and a variety of birds. The lush green forests, waterfalls, and trekking trails attract nature lovers and adventure seekers. Jeep safaris and eco-tourism activities are popular here. The sanctuary offers a peaceful retreat away from the city’s bustle. It is an ideal destination for wildlife photography and family picnics."
  },
  {
    "title": "Chandrakant Mandare Art Gallery",
    "description": "This gallery is dedicated to Chandrakant Mandare, a celebrated Marathi actor and painter. It showcases his impressive collection of paintings, particularly focusing on historical and mythological themes. Visitors can admire artworks depicting Maratha warriors, deities, and scenes from epics. The gallery highlights Kolhapur’s artistic and cultural richness. It is a must-visit for art lovers and students. The space also inspires local artists to pursue creative excellence."
  },
  {
    "title": "Kopeshwar Temple, Khidrapur",
    "description": "Located on the banks of the Krishna River near Kolhapur, Kopeshwar Temple is dedicated to Lord Shiva. Built in the 12th century, the temple is an architectural gem of the Chalukya period. Its intricately carved pillars, domes, and halls showcase the brilliance of ancient craftsmanship. The temple is unique as it also houses a shrine for Lord Vishnu, symbolizing harmony. The peaceful riverside setting adds to its divine atmosphere. It is a hidden gem for history, culture, and spirituality lovers."
  },
  {
    "title": "Radhanagari Dam",
    "description": "Radhanagari Dam, built across the Bhogawati River, is a scenic spot surrounded by dense forests. It is one of the oldest dams in Maharashtra, constructed during the reign of Shahu Maharaj. The dam not only supplies water but also supports a thriving ecosystem with migratory birds and wildlife. The monsoon season enhances its beauty with gushing water and misty landscapes. Visitors enjoy the peaceful environment for picnics and photography. It is a blend of engineering, history, and natural beauty."
  }
],


"services": [
    {
        "name": "Pune to Kolhapur Innova Cab Service",
        "description": "Enjoy a comfortable and spacious journey from Pune to Kolhapur with our Innova cab service. Perfect for families and groups, the Innova offers ample legroom, air conditioning, and luggage space. Our professional drivers ensure a safe, timely ride while providing excellent customer service for a hassle-free travel experience."
    },
    {
        "name": "Pune to Kolhapur Cab Service",
        "description": "Reliable and affordable cab services from Pune to Kolhapur tailored to your travel needs. Whether for business or leisure, we provide clean vehicles, courteous drivers, and flexible pickup/drop timings to make your long-distance trip smooth and convenient."
    },
    {
        "name": "Pune to Kolhapur Innova Cab",
        "description": "Travel in style with our Innova cab from Pune to Kolhapur. Featuring plush interiors, advanced safety features, and a professional driver, this service is ideal for group travel, weekend getaways, or business trips seeking comfort and reliability."
    },
    {
        "name": "Pune to Kolhapur Taxi Service",
        "description": "Book our trusted taxi service for your Pune to Kolhapur journey. Offering a variety of vehicles including sedans and SUVs, our experienced drivers prioritize your comfort and punctuality. Enjoy door-to-door service and real-time assistance throughout your trip."
    },
    {
        "name": "Pune to Kolhapur Cab Package",
        "description": "Customize your trip with our flexible cab packages from Pune to Kolhapur. Choose from round trips, one-way transfers, or multi-day rentals. Our packages include well-maintained vehicles, professional drivers, and competitive pricing to meet your travel preferences."
    },
    {
        "name": "Book Pune to Kolhapur Dzire Cab",
        "description": "Affordable and comfortable Dzire cab service from Pune to Kolhapur, perfect for solo travelers, couples, or small families. This sedan offers air conditioning, smooth rides, and efficient fuel economy, paired with courteous and experienced drivers."
    },
    {
        "name": "Pune to Kolhapur Innova Crysta",
        "description": "Experience premium travel with our Innova Crysta cab from Pune to Kolhapur. Equipped with spacious seating, advanced comfort amenities, and driven by professional chauffeurs, this service is perfect for corporate clients and family trips seeking luxury and convenience."
    },
    {
        "name": "Pune to Kolhapur Affordable Cab",
        "description": "Travel smart with our budget-friendly cab options from Pune to Kolhapur. We combine affordability with quality service, ensuring clean vehicles, safe driving practices, and transparent pricing for a worry-free travel experience."
    },
    {
        "name": "Pune to Kolhapur Round Trip Taxi",
        "description": "Book a round trip taxi for seamless travel between Pune and Kolhapur. Enjoy the flexibility of a dedicated vehicle and driver for your entire journey, with options for sightseeing stops, local travel, and comfortable rides at competitive rates."
    },
    {
        "name": "Pune to Kolhapur Family Cab",
        "description": "Designed for families traveling from Pune to Kolhapur, our family cabs offer spacious seating, child safety options, and extra luggage space. Our courteous drivers ensure a smooth and enjoyable journey suitable for travelers of all ages."
    },
    {
        "name": "Pune to Kolhapur Etios Taxi",
        "description": "Opt for our Toyota Etios taxi service from Pune to Kolhapur for a reliable and economical ride. This sedan is fuel-efficient and comfortable, ideal for small groups or solo travelers seeking a hassle-free trip with professional drivers."
    }
],
"tableData": [
    ["Pune to Kolhapur Innova Cab Service", "Pune to Kolhapur Cab Service"],
    ["Pune to Kolhapur Innova Cab", "Pune to Kolhapur Taxi Service"],
    ["Pune to Kolhapur Cab Package", "Book Pune to Kolhapur Dzire Cab"],
    ["Pune to Kolhapur Innova Crysta", "Pune to Kolhapur Affordable Cab"],
    ["Pune to Kolhapur Round Trip Taxi", "Pune to Kolhapur Family Cab"],
    ["Pune to Kolhapur Etios Taxi", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Kolhapur Cab Service",
        "WhyChoosedescription": "Prince Cabs offers dependable and timely cab services from Pune to Kolhapur, ideal for both leisure travelers and business commuters. Whether you’re visiting the famous Mahalakshmi Temple, exploring the local culture, or heading for corporate meetings, we ensure a smooth and comfortable journey with professional service."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our fleet consists of clean, air-conditioned vehicles with spacious seating and sufficient luggage space. Designed to provide maximum comfort during the approximately 4-5 hour journey, our cabs allow you to relax and enjoy the scenic route without any hassle."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Route Expertise",
        "WhyChoosedescription": "Our drivers are skilled professionals familiar with the Pune to Kolhapur highways, traffic patterns, and best stops along the way. They ensure safe driving practices, timely pickups, and drop-offs, allowing you to focus on your travel plans without worry."
    },
    {
        "WhyChooseheading": "Flexible Booking and Customized Travel Plans",
        "WhyChoosedescription": "Whether you need a one-way trip, round-trip, or a multi-day rental, Prince Cabs offers flexible booking options tailored to your specific requirements. You can easily book via phone, website, or WhatsApp and customize your travel itinerary for maximum convenience."
    },
    {
        "WhyChooseheading": "Strict Hygiene and Safety Measures",
        "WhyChoosedescription": "We maintain rigorous hygiene protocols to ensure your safety during the trip. Every vehicle is thoroughly cleaned and sanitized before and after each journey. Regular maintenance and safety checks guarantee a reliable and secure ride."
    },
    {
        "WhyChooseheading": "Transparent Pricing and Multiple Payment Methods",
        "WhyChoosedescription": "Our pricing is competitive, upfront, and free from hidden charges. We offer various secure payment options, including UPI, credit/debit cards, net banking, and cash, making your booking and payment process smooth and hassle-free."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for a Hassle-Free Journey",
        "WhyChoosedescription": "Our dedicated customer service team is available around the clock to assist you with bookings, route inquiries, or any travel-related questions. We strive to make your Pune to Kolhapur cab experience convenient, safe, and enjoyable from start to finish."
    }
]

























    }

const faqData = [
    {
        question: 'Does Prince Cabs offer Pune to Kolhapur cab services?',
        answer: 'Yes, Prince Cabs provides reliable and comfortable cab services from Pune to Kolhapur, perfect for business trips, family visits, and sightseeing.',
    },
    {
        question: 'What types of vehicles are available for Pune to Kolhapur travel?',
        answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and tempo travellers to accommodate solo travelers and groups of all sizes.',
    },
    {
        question: 'Are the cabs suitable for long-distance travel like Pune to Kolhapur?',
        answer: 'Absolutely! Our vehicles are well-maintained, air-conditioned, and driven by experienced drivers to ensure a smooth and safe journey.',
    },
    {
        question: 'Can I customize my itinerary for the Pune to Kolhapur trip?',
        answer: 'Yes, you can customize pickup points, drop locations, and request stopovers at popular attractions such as the Mahalaxmi Temple or Panhala Fort.',
    },
    {
        question: 'What are the charges for a Pune to Kolhapur cab?',
        answer: 'Pricing depends on vehicle type, duration, and additional requirements. Contact Prince Cabs for a tailored and competitive quote.',
    },
    {
        question: 'How do I book a Pune to Kolhapur cab with Prince Cabs?',
        answer: 'Booking is easy—call us or visit our website with your travel details, and our team will assist you in choosing the right cab for your trip.',
    },
    {
        question: 'Are the cabs clean and well-maintained for intercity travel?',
        answer: 'Yes, all our vehicles are regularly sanitized, serviced, and maintained to provide a safe and comfortable ride to Kolhapur.',
    },
];

const testimonials = [
    {
        name: "Mr. Rajesh Patil",
        position: "Frequent Traveler",
        text: "Prince Cabs made our Pune to Kolhapur journey comfortable and hassle-free. The driver was courteous and the vehicle was spotless.",
        image: "/img/testimonial/testimonial-thumb-kolhapur-1.png",
    },
    {
        name: "Mrs. Sunita Shinde",
        position: "Family Traveler",
        text: "Our family trip to Kolhapur was delightful thanks to Prince Cabs. The cab was spacious and the driver was very professional.",
        image: "/img/testimonial/testimonial-thumb-kolhapur-2.png",
    },
];




























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Kolhapur Cab",
  "image": "https://princecab.com/assets/images/pune-kolhapur-cab.jpg",
  "description": "Book Pune to Kolhapur cab service with Prince Cabs. Reliable and affordable taxi options including Innova Crysta, Dzire, and Etios. Perfect for round trips, family travel, and convenient one-way rides. 24/7 online booking available.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "6850"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4500",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-kolhapur-cab"
  }
};





    return (
        <div>
<Helmet>
  <title>Pune to Kolhapur Cab | Reliable & Affordable Taxi Service | Prince Cabs</title>
  <meta
    name="description"
    content="Prince Cabs offers Pune to Kolhapur taxi service with Innova, Dzire, and Etios cabs. Ideal for round trips, family travel, and one-way rides. Affordable fares with 24/7 online booking."
  />
  <meta
    name="keywords"
    content="Pune to Kolhapur Innova Cab Service, Pune to Kolhapur Cab Service, Pune to Kolhapur Innova Cab, Pune to Kolhapur Taxi Service, Pune to Kolhapur Cab Package, Book Pune to Kolhapur Dzire Cab, Pune to Kolhapur Innova Crysta, Pune to Kolhapur Affordable Cab, Pune to Kolhapur Round Trip Taxi, Pune to Kolhapur Family Cab, Pune to Kolhapur Etios Taxi"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/12.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetokolhapurcab;